import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';

import Modal from '../../../../common/Modal';

const BrandPromoModal = ({ close }) => (
  <Modal title={t('settings:promo_codes.brand_modal.title')} close={close} showCloseButton>
    <div className="u-mv u-ph+ u-margin-auto u-max-width-600">
      {t('settings:promo_codes.brand_modal.message')}
    </div>
  </Modal>
);

BrandPromoModal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default BrandPromoModal;
